import { ElementType, forwardRef } from 'react';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useThreadHeaderContext } from '@frontend/thread-header-context';
import { theme } from '@frontend/theme';
import { PolymorphicComponentPropWithoutRef } from '@frontend/design-system';

type HeaderProps<E extends ElementType = 'div'> = PolymorphicComponentPropWithoutRef<E, Record<string, unknown>>;

export const Header = forwardRef(
  <E extends ElementType = 'div'>({ as, children, ...rest }: HeaderProps<E>, ref: React.Ref<any>) => {
    const { variant } = useThreadHeaderContext();
    const Component = as || 'div';
    const isSmallMode = useMatchMedia({ maxWidth: breakpoints.xsmall.max });

    return (
      <Component
        css={{
          display: 'flex',
          alignItems: variant === 'small' ? 'start' : 'center',
          padding: isSmallMode ? theme.spacing(0, 1) : theme.spacing(0, 2),
          columnGap: theme.spacing(1),
          position: 'relative',
          width: '100%',
          justifyContent: 'space-between',
        }}
        {...rest}
        ref={ref}
      >
        {children}
      </Component>
    );
  }
);
Header.displayName = 'ThreadHeader.Header';
